module.exports = __webpack_public_path__ + "static/media/yourspace.add66261.svg";